<template>
  <Dialog :commonDialog="creditDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      Record Credit Notes for {{ detail.barcode }}  #{{paymentNotesCreate.barcode}}
    </template>
    <template v-slot:body>
      <v-container fluid>
        <v-form
          ref="paymentCreditForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="onSubmit()"
        >
          <v-row>
            <v-col md="6">
              <v-layout align-center>
                <v-flex md3
                  ><label for="payment-date">Credit Note Date</label></v-flex
                >
                <v-flex md9>
                  <DatePicker
                    solo
                    id="payment-date"
                    :pageLoading="pageLoading"
                    placeholder="Payment Date"
                    v-on:update:date-picker="setPaymentDate"
                  ></DatePicker>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col md="6">
              <v-layout align-center>
                <v-flex md3
                  ><label for="transaction-id" class="align-right"
                    >Transaction ID</label
                  ></v-flex
                >
                <v-flex md9>
                  <v-text-field
                    id="transaction-id"
                    dense
                    color="cyan"
                    filled
                    :disabled="pageLoading"
                    v-model.trim="paymentNotesCreate.transaction_id"
                    label="Transaction ID"
                    :rules="[
                      validateRules.minLength(
                        paymentNotesCreate.transaction_id,
                        'Transaction ID',
                        1
                      ),
                      validateRules.maxLength(
                        paymentNotesCreate.transaction_id,
                        'Transaction ID',
                        100
                      ),
                    ]"
                    solo
                    flat
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <label class="font-weight-600 font-size-16 mb-2 d-block"
                >Invoice Line Items</label
              >
              <invoice-line-item
                ref="creditNoteLineItem"
                :show-price="detail.show_price"
                :discount-level="
                  detail.discount_type == 2 ? 'line_item' : 'transaction'
                "
                :related-id="detail.id"
                :related-type="2"
                @validation-state="updateLineItemValidation"
                is-invoice
                purpose="credit-note"
              />
            </v-col>
            <v-col md="12">
              <v-row>
                <v-col md="12">
                  <v-row>
                    <v-col md="6" offset-md="6">
                      <table width="100%" style="table-layout: fixed">
                        <tbody>
                          <tr v-if="!tax_active && detail.tax_value > 0">
                            <td
                              width="60%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              Inclusive of GST
                            </td>
                            <td
                              width="40%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              {{ formatMoney(inclusiveGst) }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              width="60%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              Sub Total
                            </td>
                            <td
                              width="40%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              {{ formatMoney(subtotal) }}
                            </td>
                          </tr>
                          <tr v-if="tax_active">
                            <td
                              width="60%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              Tax [GST {{ gst_value }}%]
                            </td>
                            <td
                              width="40%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                            >
                              {{ formatMoney(gst) }}
                            </td>
                          </tr>
                          <tr class="font-size-19">
                            <td
                              width="60%"
                              valign="middle"
                              align="right"
                              class="font-weight-600 black--text"
                            >
                              Total Credit Note Amount
                            </td>
                            <td
                              width="40%"
                              valign="middle"
                              align="right"
                              class="font-weight-600"
                              style="color: red"
                            >
                              {{ formatMoney(paymentNotesCreate.amount) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <label for="note">Leave a note</label>
              <TextAreaField
                auto-grow
                dense
                filled
                color="cyan"
                v-model="paymentNotesCreate.admin_notes"
                solo
                flat
                row-height="25"
                counter="250"
              />
            </v-col>
            <v-col md="12">
              <label for="attachments">Attachments</label>
              <FileTemplate
                id="attachments"
                v-on:file:updated="updateFiles"
                allowUpload
              ></FileTemplate>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <ManagePaymentMode
        :commonDialog="managePaymentModeDialog"
        :paymentMode="paymentModeList"
        v-on:close-dialog="managePaymentModeDialog = false"
        v-on:get-payment-mode="getAttributes(['payment_modes'])"
      ></ManagePaymentMode>
    </template>
    <template v-slot:action>
      <v-btn
        v-on:click="$emit('close', true)"
        :disabled="formLoading || pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!formValid || formLoading || pageLoading"
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        v-on:click="onSubmit"
        color="cyan"
      >
        Save
      </v-btn>
    </template>
  </Dialog>
</template>
<style scoped>
.count-style {
  font-weight: 600 !important;
  font-size: 18px !important;
}
</style>
<script>
import moment from "moment-timezone";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { QUERY, POST } from "@/core/services/store/request.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import FileTemplate from "@/view/pages/partials/FileTemplate.vue";
import ManagePaymentMode from "@/view/pages/partials/Manage-Payment-Mode.vue";
import InvoiceLineItem from "@/view/components/InvoiceLineItem.vue";
// import { ErrorEventBus } from "@/core/lib/message.lib";
import CommonMixin from "@/core/plugins/common-mixin.js";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import { toBtxNumber } from "@/core/services/common.service";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    creditDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formLoading: false,
      pageLoading: false,
      paymentMinDate: null,
      managePaymentModeDialog: false,
      paymentModeList: [],
      isLineItemValid: false,
      selectedLineItems: [],
      subtotal: 0,
      tax_active: false,
      gst_value: 9,
      gst: 0,
      inclusiveGst: 0,
      paymentNotesCreate: {
        amount: null,
        transaction_id: null,
        admin_notes: null,
        payment_date: null,
        documents: null,
        barcode: null,
      },
    };
  },

  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.hasSelectedLineItems) {
          this.paymentNotesCreate.received = 0;
        }

        // tax_value = GST rate on the invoice (e.g. "9.00")
        // tax_applied = whether GST was actually applied/charged separately on the invoice ("1" or "0")
        this.gst_value =
          this.detail?.tax_value > 0 ? Number(this.detail.tax_value) : 9;
        this.tax_active = this.detail?.tax_applied == 1;

        this.calculate_total();
      },
    },
  },

  methods: {
    setPaymentDate(param) {
      this.paymentNotesCreate.payment_date = param;
    },
    updateFiles(param) {
      this.paymentNotesCreate.documents = param;
    },

    computeLineItemTotal(row) {
      const qty = toBtxNumber(row.quantity);
      const rate = toBtxNumber(row.rate);
      let total = this.accountingToFixed(qty * rate);

      if (total <= 0) {
        return 0;
      }

      let discount = 0;
      const discountType = this.lodash.toSafeInteger(row.discount_type);
      const discountValue = toBtxNumber(row.discount_value);

      if (discountValue > 0) {
        if (discountType === 1) {
          discount = discountValue;
        } else if (discountType === 2) {
          discount = this.accountingToFixed(
            (toBtxNumber(total) * discountValue) / 100
          );
        }
      }

      total = toBtxNumber(total) - toBtxNumber(discount);
      return total < 0 ? 0 : total;
    },

    updateLineItemValidation(isValid) {
      this.isLineItemValid = Boolean(isValid);
      this.recalculateFromLineItems();
    },

    recalculateFromLineItems() {
      const comp = this.$refs.creditNoteLineItem;
      const lineItems = comp?.visibleLineItems ?? [];
      const selected = lineItems.filter(
        (row) => row && row.product_type !== "header" && row.is_checked
      );

      this.selectedLineItems = selected.map((row) => ({
        ...row,
        total: this.computeLineItemTotal(row),
      }));

      this.calculate_total();
    },

    calculate_total() {
      this.subtotal = 0;
      for (const row of this.selectedLineItems) {
        this.subtotal = this.accountingToFixed(
          toBtxNumber(this.subtotal) + toBtxNumber(row.total)
        );
      }

      this.gst = 0;
      this.inclusiveGst = 0;

      if (this.tax_active) {
        this.gst = this.accountingToFixed(
          (toBtxNumber(this.subtotal) * toBtxNumber(this.gst_value)) / 100
        );
      } else if (this.detail?.tax_value > 0) {
        this.inclusiveGst = this.accountingToFixed(
          (toBtxNumber(this.subtotal) * toBtxNumber(this.gst_value)) /
            (100 + toBtxNumber(this.gst_value))
        );
      }

      this.paymentNotesCreate.amount = this.accountingToFixed(
        toBtxNumber(this.subtotal) + toBtxNumber(this.gst)
      );
    },

    onSubmit() {
      const _this = this;
      let status = 0;
      if (!_this.$refs.paymentCreditForm.validate()) {
        return false;
      }
      if (_this.detail?.total == _this.paymentNotesCreate.amount) {
        status = 4;
      } else {
        status = 3;
      }
      const formData = {
        action: "mark_as_paid",
        invoice: _this.lodash.toSafeInteger(_this.detail.id) || 0,
        amount: _this.lodash.toNumber(_this.paymentNotesCreate.amount) || 0.0,
        payment_date: _this.paymentNotesCreate.payment_date || null,
        admin_note: _this.paymentNotesCreate.admin_notes || null,
        status: status,
        transaction_id: _this.paymentNotesCreate.transaction_id || null,
        payment_mode:
          _this.lodash.toSafeInteger(_this.paymentNotesCreate.payment_mode) ||
          0,
        documents: _this.paymentNotesCreate.documents || [],
        line_items: _this.selectedLineItems,
        tax_applied: _this.tax_active ? 1 : 0,
        tax_type: _this.detail?.tax_type ?? 1,
        tax_value: _this.gst_value,
        discount_type: 2,
        discount_value_type: 2,
      };

      // if (this.paymentNotesCreate.amount < 0) {
      //   ErrorEventBus.$emit(
      //     "update:error"`Please enter an amount greater than zero.`
      //   );
      //   return false;
      // }

      _this.formLoading = true;

      _this.$store
        .dispatch(POST, { url: "payment-credit-notes", data: formData })
        .then(() => {
          _this.$emit("close", true);
          _this.$emit("success", true);
        })
        .catch((error) => {
          _this.logError(error);
          _this.$emit("error", true);
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
    getAttributes(attribute) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: "payment-credit-notes/options",
           data: {
            attribute,
              entity_id: _this.lodash.toSafeInteger(_this.detail?.entity_id) || 1,
          },
        })
        .then(({ data }) => {
          if (_this.lodash.isEmpty(data) === false) {
            if (_this.lodash.isEmpty(data.payment_modes) === false) {
              _this.paymentModeList = data.payment_modes;
            }
            if (data.barcode) {
              _this.paymentNotesCreate.barcode = data.barcode;
            }
          }
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.getAttributes(["payment_modes", "barcode"]);
    this.paymentMinDate = moment().format("YYYY-MM-DD");
  },
  components: {
    Dialog,
    DatePicker,
    FileTemplate,
    ManagePaymentMode,
    TextAreaField,
    "invoice-line-item": InvoiceLineItem,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },

    balanceAmount() {
      const total = Number(this.detail?.total || 0);
      const paid = Number(this.detail?.paid_amount || 0);
      const refunded = Number(this.detail?.refund_amount || 0);

      return total - paid + refunded;
    },

    hasSelectedLineItems() {
      return this.selectedLineItems.length > 0;
    },
  },
};
</script>
